import { jwtDecode } from "jwt-decode";

export function getUserFromToken() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    console.log("Decoded user token:", jwtDecode(token));
    return jwtDecode(token); // includes userId, email, and role
  } catch (error) {
    return null;
  }
}

export function isAuthenticated() {
  return !!localStorage.getItem("token");
}

export function getUserRole() {
  const user = getUserFromToken();
  return user?.role || null;
}

export function getUserEmail() {
  const user = getUserFromToken();
  return user?.email || null;
}

export function logout() {
  localStorage.removeItem("token");
}
